import React from 'react'
import { ContactCol, ContactInfor, MapHodlerDiv, ContactMenu, AboutAndWork, AboutAndWorkP, MapHodler, PoweredBy } from './StyledComponents'
import { contactUsInfo } from '../../data/websiteData'
import { contactUsData } from '../../data/websiteData';
import { Grid, Row, Col } from '../../styles/GlobalTheme/GlobalStyledComponents'
import { SvgIcons } from '../Card/SvgComponents'
import px2vw from '../../utils/px2vw'
import { Link } from 'react-router-dom';

const ContactUsInfo = () => {

    function getSvgSize() {
        let svgsize = px2vw(24);
        if (window.innerWidth <= 425) {
            svgsize = px2vw(125);
        } 
        return svgsize;
    }

    
    return (
        <Grid>
            <Row justifyContent="space-between" pt="78">
                <ContactCol>
                    <ContactMenu> Contact Us</ContactMenu>
                    {contactUsInfo.items.map((item, index) => (
                        <Row pb="20" justifyContent="space-evently">
                            <SvgIcons pageshow={item.svgIcon} size={getSvgSize() }></SvgIcons>
                            <ContactInfor>{item.contact}</ContactInfor>
                        </Row>
                    ))}
                </ContactCol>
                <AboutAndWork>                
                    <AboutAndWorkP>Work with Us</AboutAndWorkP>
                    <AboutAndWorkP><Link to="/aboutUs"  style={{ textDecoration: 'none' }}>About Us</Link></AboutAndWorkP>
                </AboutAndWork>
            </Row>
            <MapHodlerDiv>
                <MapHodler src={contactUsData.headerImage} alt="contactUs cover"></MapHodler>   
                <PoweredBy> &copy; Qberaa B.V <br/>Site developed by <span style={{ color: '#0000FF', letterSpacing: '1px'  }}>TeamSamhara</span></PoweredBy>                            
            </MapHodlerDiv>             
            
        </Grid>
    )
}

export default ContactUsInfo
